import type { Nullable } from "vite-node"
import oneAndNegOne from "../../../ldsh/oneAndNegOne"
import eightDirectionCharsLowerCase from "../../direction/eightDirectionCharsLowerCase"
import normalizeCircularOffset from "../../direction/normalizeCircularOffset"
import type { TileGraphNode } from "../../engine/TileGraphNode/TileGraphNode.type"
import entityDisplayName from "../../entity/entityDisplayName"
import isEntityLayerIdTerrain1 from "../../entity/EntityLayerId/isEntityLayerIdTerrain1"
import { isEntityShoal } from "../../entity/entityTypeMetaList.generated"
import isEntityWater from "../../entity/isEntityWater"
import type { EntityWaterWithCurrent } from "../../entity/isEntityWaterWithCurrent"
import type { WaterFlowError } from "./WaterFlowError.type"
import { WaterFlowErrorTypeId } from "./WaterFlowErrorTypeId.enum"

export default function getWaterFlowError(
  ent0: EntityWaterWithCurrent,
  tpNodeList: TileGraphNode[],
  gridWidth: number
): Nullable<WaterFlowError> {
  const nodeIndex0 = ent0.x + ent0.y * gridWidth
  const node0 = tpNodeList[nodeIndex0]!
  const eightDirIndex = ent0.current.edc
  const dirChar = eightDirectionCharsLowerCase[eightDirIndex]
  const node1 = node0[dirChar]
  if (node1) {
    const ent1 = node1.ents().find(isEntityLayerIdTerrain1)
    if (ent1) {
      if (isEntityWater(ent1)) {
        // maybe other rules later
      } else {
        return {
          index: nodeIndex0,
          type: WaterFlowErrorTypeId.PointingAtLand,
          message: `${entityDisplayName(ent0)}(id:${ent0.id}x:${ent0.x}y:${ent0.y}) is pointing(${dirChar}) at land ${entityDisplayName(ent1)}(id:${ent1.id}x:${ent1.x}y:${ent1.y})`,
        }
      }
    }
    const isDiagonal = eightDirIndex % 2 === 1
    if (isDiagonal) {
      for (const offset of oneAndNegOne) {
        const eightDirIndex2 = normalizeCircularOffset(eightDirIndex + offset, 8)
        const dirChar2 = eightDirectionCharsLowerCase[eightDirIndex2]
        const node2 = node0[dirChar2]
        if (node2) {
          const ent2 = node2.ents().find(isEntityLayerIdTerrain1)
          if (ent2) {
            // shoals are allowed to be bumped, as their corners are water
            if (isEntityWater(ent2) || isEntityShoal(ent2)) {
              // maybe other rules later
            } else {
              return {
                index: nodeIndex0,
                type: WaterFlowErrorTypeId.PointingAtLandDiagonal,
                message: `${entityDisplayName(ent0)}(id:${ent0.id}x:${ent0.x}y:${ent0.y}) is diagonally (${dirChar}) bumping land ${entityDisplayName(ent2)}(id:${ent2.id}x:${ent2.x}y:${ent2.y})`,
              }
            }
          }
        }
      }
    }
  }
}